import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Optimizes an image URL by appending transformation parameters.
 * Currently supports Unsplash and provides a template for Swell/other CDNs.
 *
 * @param {string} url - The original image URL
 * @param {object} options - Optimization options
 * @param {number} options.width - Desired width
 * @param {number} options.quality - Image quality (1-100)
 * @param {string} options.format - Image format (format, webp, etc.)
 * @returns {string} - The optimized URL
 */
export const getOptimizedImageUrl = (url, { width, quality = 80, format = 'format' } = {}) => {
  if (!url || typeof url !== 'string' || url.startsWith('data:')) return url;

  try {
    const urlObj = new URL(url);

    // Unsplash optimization
    if (url.includes('images.unsplash.com')) {
      if (width) urlObj.searchParams.set('w', width.toString());
      urlObj.searchParams.set('q', quality.toString());
      urlObj.searchParams.set('auto', format);
      // Ensure fit=crop for consistent aspect ratios in grids
      if (!urlObj.searchParams.has('fit')) {
        urlObj.searchParams.set('fit', 'crop');
      }
      return urlObj.toString();
    }

    // Swell CDN optimization (placeholder - adjust based on actual CDN used)
    if (url.includes('cdn.swell.store')) {
      if (width) urlObj.searchParams.set('width', width.toString());
      urlObj.searchParams.set('quality', quality.toString());
      urlObj.searchParams.set('format', format);
      return urlObj.toString();
    }

    return url;
  } catch (e) {
    // If URL is invalid, return as is
    return url;
  }
};
